import keycloak from './Keycloak.js';

function bearerAuthHeader(contentType = 'application/json', accept = 'application/json') {
    if (keycloak.token) {
        return {
            'Accept': accept,
            'Content-Type': contentType,
            'Authorization': 'Bearer ' + keycloak.token
        };
    } else {
        return {
            'Accept': accept,
            'Content-Type': contentType
        };
    }
}

export function authHeader() {
    return bearerAuthHeader('application/json', 'application/json');
}

export function authProblemHeader() {
    return bearerAuthHeader('application/json', 'application/problem+json');
}

export function authHeaderSet() {
    return bearerAuthHeader('application/json', 'application/hal+json');
}

export function authHeaderPatch() {
    return bearerAuthHeader('application/json', 'application/problem+json');
}

export function anonHeader() {
    return {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };
}

export function recaptchaHeader(recaptchaValue) {
    return {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'recaptcha-token': recaptchaValue
    };
}

export function recaptchaHeaderSet(recaptchaValue) {
    return {
        'Accept': 'application/hal+json',
        'Content-Type': 'application/json',
        'recaptcha-token': recaptchaValue
    };
}